"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleModule = void 0;
const router_1 = require("client/components/router");
const google_sync_1 = require("./modules/google-sync/google-sync");
class GoogleModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("sync", /^\/sync?$/, google_sync_1.SyncModule);
    }
}
exports.GoogleModule = GoogleModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sync/sync.tsx
// module id = 4131
// module chunks = 0